<script lang="ts">
  import i18n from '../../i18n'
  import ContextMenuContent from '../context-menu/ContextMenuContent.svelte'
  import ContextMenuSeparator from '../context-menu/ContextMenuSeparator.svelte'
  import ContextMenuItem from '../context-menu/ContextMenuItem.svelte'
  import usePrinterQueries from '../../routes/project/hooks/usePrinterQueries'

  type Props = {
    printerId: string
    onRename?: () => void
  }

  let { printerId, onRename }: Props = $props()
  const { focusCamera, removeMutation } = usePrinterQueries()
</script>

<ContextMenuContent>
  {#if onRename}
    <ContextMenuItem onClick={onRename}>
      {$i18n.t('project.leftBar.printers.contextMenu.rename')}
    </ContextMenuItem>
  {/if}
  <ContextMenuItem onClick={() => focusCamera(printerId)}>
    {$i18n.t('project.leftBar.printers.contextMenu.focus')}
  </ContextMenuItem>
  <ContextMenuSeparator />
  <ContextMenuItem
    onClick={() => removeMutation.mutate(printerId)}
    variant="destructive"
  >
    {$i18n.t('project.leftBar.printers.contextMenu.delete')}
  </ContextMenuItem>
</ContextMenuContent>
